/**
 * Convert dollar amount to Stripe price format (cents)
 */
export const toStripePrice = (amount?: number): number => {
  if (amount === undefined || amount === null) return 0;
  return Math.round(amount * 100);
};

/**
 * Convert Stripe price format (cents) to dollar amount
 */
export const fromStripePrice = (amount?: number): number => {
  if (amount === undefined || amount === null) return 0;
  return amount / 100;
};
